var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('author-jinNang-list',{attrs:{"list":_vm.authorjinNangList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }